/* =========================================================
   LUMINIAIRE FRANCE — PRODUCT GALLERY
   Galerie • Miniatures • Zoom • Navigation • Swipe mobile
   ========================================================= */

(function () {
  'use strict';

  function initProductGallery(card) {
    if (!card || card.dataset.lfGalleryInit === '1') return;

    const mainImage = card.querySelector(
      '.lf-product-card-premium__main-image'
    );

    const imageElement = card.querySelector(
      '.lf-main-product-image'
    );

    const thumbs = Array.from(
      card.querySelectorAll('.lf-product-thumb')
    );

    if (!mainImage || !imageElement || !thumbs.length) {
      return;
    }

    card.dataset.lfGalleryInit = '1';

    /* =====================================================
       CONSTRUCTION DE LA GALERIE
       ===================================================== */

    const images = thumbs
      .map((thumb) => ({
        src: thumb.dataset.image || '',
        alt:
          thumb.querySelector('img')?.alt ||
          imageElement.alt ||
          ''
      }))
      .filter((image) => image.src);

    if (!images.length) return;

    let currentIndex = 0;

    /* =====================================================
       CREATION DU ZOOM
       ===================================================== */

    const zoom = document.createElement('div');

    zoom.className = 'lf-zoom';

    zoom.setAttribute(
      'aria-hidden',
      'true'
    );

    zoom.innerHTML = `
      <button
        type="button"
        class="lf-zoom-x"
        aria-label="Fermer"
      >
        ×
      </button>

      <button
        type="button"
        class="lf-zoom-p"
        aria-label="Image précédente"
      >
        ‹
      </button>

      <img
        src=""
        alt=""
        width="1200"
        height="1200"
      >

      <button
        type="button"
        class="lf-zoom-n"
        aria-label="Image suivante"
      >
        ›
      </button>
    `;

    document.body.appendChild(zoom);

    const zoomImage =
      zoom.querySelector('img');

    const closeButton =
      zoom.querySelector('.lf-zoom-x');

    const previousButton =
      zoom.querySelector('.lf-zoom-p');

    const nextButton =
      zoom.querySelector('.lf-zoom-n');

    /* =====================================================
       AFFICHAGE IMAGE
       ===================================================== */

    function showImage(index) {

      if (!images.length) return;

      currentIndex =
        (index + images.length) %
        images.length;

      const image =
        images[currentIndex];

      zoomImage.src =
        image.src;

      zoomImage.alt =
        image.alt;

      thumbs.forEach(
        (thumb, thumbIndex) => {

          thumb.classList.toggle(
            'is-active',
            thumbIndex === currentIndex
          );
        }
      );
    }

    /* =====================================================
       CHANGEMENT IMAGE PRINCIPALE
       ===================================================== */

    function setMainImage(
      src,
      alt,
      index
    ) {

      if (!src) return;

      imageElement.src =
        src;

      if (alt) {
        imageElement.alt =
          alt;
      }

      if (
        typeof index === 'number' &&
        index >= 0
      ) {
        currentIndex =
          index;
      }

      thumbs.forEach(
        (thumb, thumbIndex) => {

          thumb.classList.toggle(
            'is-active',
            thumbIndex === currentIndex
          );
        }
      );
    }

    /* =====================================================
       CLIC MINIATURES
       ===================================================== */

    thumbs.forEach(
      (thumb, index) => {

        thumb.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            const src =
              thumb.dataset.image;

            const thumbImage =
              thumb.querySelector('img');

            const alt =
              thumbImage?.alt ||
              imageElement.alt ||
              '';

            setMainImage(
              src,
              alt,
              index
            );
          }
        );
      }
    );

    /* =====================================================
       DETECTION IMAGE ACTUELLE
       ===================================================== */

    const initialIndex =
      images.findIndex(
        (image) =>
          image.src ===
          imageElement.currentSrc ||
          image.src ===
          imageElement.src
      );

    if (initialIndex >= 0) {
      currentIndex =
        initialIndex;
    } else {
      const activeThumb =
        thumbs.findIndex(
          (thumb) =>
            thumb.classList.contains(
              'is-active'
            )
        );

      currentIndex =
        activeThumb >= 0
          ? activeThumb
          : 0;
    }

    /* =====================================================
       OUVERTURE ZOOM
       ===================================================== */

    function openZoom() {

      showImage(
        currentIndex
      );

      zoom.classList.add(
        'on'
      );

      zoom.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.style.overflow =
        'hidden';
    }

    /* =====================================================
       FERMETURE ZOOM
       ===================================================== */

    function closeZoom() {

      zoom.classList.remove(
        'on'
      );

      zoom.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.style.overflow =
        '';
    }

    /* =====================================================
       IMAGE PRINCIPALE → ZOOM
       ===================================================== */

    mainImage.addEventListener(
      'click',
      function (event) {

        if (
          event.target.closest(
            'button'
          )
        ) {
          return;
        }

        openZoom();
      }
    );

    /* =====================================================
       NAVIGATION
       ===================================================== */

    function previousImage() {

      showImage(
        currentIndex - 1
      );
    }

    function nextImage() {

      showImage(
        currentIndex + 1
      );
    }

    closeButton.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        closeZoom();
      }
    );

    previousButton.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        previousImage();
      }
    );

    nextButton.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        nextImage();
      }
    );

    /* =====================================================
       CLIC SUR FOND
       ===================================================== */

    zoom.addEventListener(
      'click',
      function (event) {

        if (
          event.target === zoom
        ) {
          closeZoom();
        }
      }
    );

    /* =====================================================
       CLAVIER
       ===================================================== */

    function keyboardHandler(event) {

      if (
        !zoom.classList.contains(
          'on'
        )
      ) {
        return;
      }

      if (
        event.key === 'Escape'
      ) {

        event.preventDefault();

        closeZoom();

        return;
      }

      if (
        event.key === 'ArrowLeft'
      ) {

        event.preventDefault();

        previousImage();

        return;
      }

      if (
        event.key === 'ArrowRight'
      ) {

        event.preventDefault();

        nextImage();

        return;
      }
    }

    document.addEventListener(
      'keydown',
      keyboardHandler
    );

    /* =====================================================
       SWIPE MOBILE
       ===================================================== */

    let touchStartX = 0;
    let touchStartY = 0;

    zoom.addEventListener(
      'touchstart',
      function (event) {

        if (
          !event.touches ||
          !event.touches.length
        ) {
          return;
        }

        touchStartX =
          event.touches[0].clientX;

        touchStartY =
          event.touches[0].clientY;
      },
      {
        passive: true
      }
    );

    zoom.addEventListener(
      'touchend',
      function (event) {

        if (
          !event.changedTouches ||
          !event.changedTouches.length
        ) {
          return;
        }

        const touch =
          event.changedTouches[0];

        const deltaX =
          touch.clientX -
          touchStartX;

        const deltaY =
          touch.clientY -
          touchStartY;

        /*
         * On ne déclenche le swipe
         * que si le mouvement est
         * principalement horizontal.
         */

        if (
          Math.abs(deltaX) > 45 &&
          Math.abs(deltaX) >
            Math.abs(deltaY)
        ) {

          if (deltaX < 0) {
            nextImage();
          } else {
            previousImage();
          }
        }
      },
      {
        passive: true
      }
    );

    /* =====================================================
       PRECHARGEMENT DES IMAGES
       ===================================================== */

    images.forEach(
      (image) => {

        const preload =
          new Image();

        preload.src =
          image.src;
      }
    );

    /* =====================================================
       EXPOSITION OPTIONNELLE
       Permet à d'autres scripts de
       demander l'ouverture du zoom.
       ===================================================== */

    card.lfProductGallery = {
      open: openZoom,
      close: closeZoom,
      next: nextImage,
      previous: previousImage,
      show: showImage
    };
  }

  /* =======================================================
     INITIALISATION
     ======================================================= */

  function initAllProductGalleries() {

    document
      .querySelectorAll(
        '.lf-product-card-premium'
      )
      .forEach(
        initProductGallery
      );
  }

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllProductGalleries
    );

  } else {

    initAllProductGalleries();
  }

  /* =======================================================
     SHOPIFY — RECHARGEMENT DES SECTIONS
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    initAllProductGalleries
  );

})();